import { useRelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { type IMapLayer, type MapLayerType } from '../../layers/MapLayer.ts';
import { MapLayersConfigSection } from '../MapLayersConfigSection.tsx';

export interface IMapPrintImageLayersSectionProps {
  allowedTypes?: MapLayerType[];
}

// Crea il proprio RelationEditor perché vive dentro un FormHandler nested
// con form context separato.
export function MapPrintImageLayersSection(
  props: IMapPrintImageLayersSectionProps,
) {
  const editor = useRelationEditor<IMapLayer>('layers');
  return (
    <MapLayersConfigSection editor={editor} allowedTypes={props.allowedTypes} />
  );
}
